import { useFeatureFlags } from '@/hooks/use-feature-flags';
import AudiencesPage from '@/pages/audiences.page';
import AudiencesPreviewPage from '@/pages/audiences-preview.page';

export default function AudiencesIndexPage() {
  const { data, isPending } = useFeatureFlags();

  if (isPending) {
    return <div></div>;
  }

  return data?.audiencesEnabled ? <AudiencesPage /> : <AudiencesPreviewPage />;
}
